import React from 'react'
import { Elements } from '@stripe/react-stripe-js'
import getStripe from '../lib/get-stripe'

const fontPath =
  'https://res.cloudinary.com/scentre-group-au/raw/upload/v1659999858/fonts/CeraPRO-Regular.woff'

const font = {
  src: `url(${fontPath}) format("woff")`,
  family: 'Cera PRO',
}

export const StripeWrapper: React.FunctionComponent<
  React.PropsWithChildren<unknown>
> = ({ children }) => {
  return (
    <Elements
      stripe={getStripe()}
      options={{ fonts: [{ ...font, style: 'normal' }] }}
    >
      {children}
    </Elements>
  )
}

export default StripeWrapper
